import React from 'react';
import styled, { keyframes } from 'styles/styled-components';
import translations from 'translations';
import messages from './messages';

interface AnalyzingStateProps {
  progress: number;
}

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 24px;
  gap: 24px;
`;

const Spinner = styled.div`
  width: 48px;
  height: 48px;
  border: 4px solid #c6f3c9;
  border-top-color: #43a047;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
  flex-shrink: 0;
`;

const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  line-height: 28px;
  color: #111827;
  text-align: center;
`;

const Subtext = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #4b5563;
  text-align: center;
`;

const ProgressBlock = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
`;

const ProgressBar = styled.div`
  width: 323px;
  height: 8px;
  background: #e6f9e7;
  border-radius: 80px;
  overflow: hidden;
`;

const ProgressFill = styled.div<{ percent: number }>`
  height: 100%;
  width: ${({ percent }) => percent}%;
  background: #43a047;
  border-radius: 80px;
  transition: width 0.4s ease;
`;

const ProgressLabel = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: #4b5563;
  text-align: center;
`;

const AnalyzingState = ({ progress }: AnalyzingStateProps) => {
  const clamped = Math.min(progress, 100);
  return (
    <Wrapper>
      <Spinner />
      <TextBlock>
        <Title>{translations(messages.analyzing)}</Title>
        <Subtext>{translations(messages.analyzingSubtext)}</Subtext>
      </TextBlock>
      <ProgressBlock>
        <ProgressBar>
          <ProgressFill percent={clamped} />
        </ProgressBar>
        <ProgressLabel>{clamped}%</ProgressLabel>
      </ProgressBlock>
    </Wrapper>
  );
};

export default AnalyzingState;
